import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { api1 } from "../utils/axiosInstance";
import { useNavigate } from 'react-router-dom';
import { setSubscription } from "../redux/authSlice";
import { SubscriptionPlans } from "../components/SubscriptionPlans";
import { HEADING_COLOR } from "../constants/colors";
import { API_ENDPOINTS } from "../services/apiEndpoints";

const Subscription = () => {
  const { id: userId, subscription } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const response = await api1.get(`${API_ENDPOINTS.GET_USER_BY_ID}/${userId}`);
        const userData = response.data.data || response.data;
        if (userData && userData.subscription) {
          dispatch(setSubscription(userData.subscription));
        } else {
          console.log("Full response structure:", JSON.stringify(response.data, null, 2));
        }
      } catch (err) {
        console.error("Failed to fetch subscription:", err);
      }
    };

    if (userId && !subscription) {
      fetchSubscription();
    }
  }, [userId, subscription, dispatch]);

  const handleSubscription = async (plan) => {
    try {
      const response = await api1.post("/api/subscription/checkout", { userId, plan });

      if (response?.data.url) {
          const updatedSubscription = {
          plan,
          isSubscribed: true,
          startDate: new Date().toISOString(),
          expiresAt: null
        };
        dispatch(setSubscription(updatedSubscription));
        window.location.href = response.data.url;
      } else if (plan === "free" && response?.data.message === "Free plan activated.") {
        const updatedSubscription = {
          plan: "free",
          isSubscribed: true,
          startDate: new Date().toISOString(),
          expiresAt: null
        };
        dispatch(setSubscription(updatedSubscription));
        navigate("/dashboard/home");
      } else {
        toast.error("Failed to get payment link.");
      }
    } catch (err) {
      console.error("Stripe Checkout Error:", err);
    }
  };

  const handlePlanSelect = (plan) => {
    handleSubscription(plan);
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="bg-white p-6 rounded-lg shadow-md w-full h-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2" style={{ color: HEADING_COLOR }}>Choose Your Career Path</h1>
          <p className="text-gray-500 text-base">
            Select the plan that best fits your career development needs and unlock AI-powered insights
          </p>
        </div>

        <SubscriptionPlans 
          variant="subscription"
          selectedPlan={subscription?.plan}
          onPlanSelect={handlePlanSelect}
        />

        <div className="mt-12 pt-8 border border-gray-400 rounded-lg">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Need Help Choosing?</h2>
            <p className="text-gray-500 mb-6 max-w-2xl mx-auto">
              Not sure which plan is right for you? Start with our free tier to explore basic features, or contact our career specialists for personalized recommendations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-3">
              <button 
                onClick={() => navigate("/dashboard/help-and-support/support")}
                className="px-3 py-1 border border-gray-300 text-black rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
              >
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
